
import { getKeys, PartialRecord } from "@base/util/TypeUtil";
import { ILanguageDbItem, LanguageType } from "@biz/Definitions";
import { de_AT } from "@biz/language/de_AT";
import { en_GB } from "@biz/language/en_GB";
import { es_ES } from "@biz/language/es_ES";
import { fr_FR } from "@biz/language/fr_FR";
import { it_IT } from "@biz/language/it_IT";

export const languageFallbacks: LanguageType[] = ["en_GB", "de_AT"];

export type LanguageFile = typeof de_AT;
export type LanguageId = keyof LanguageFile;

const rawBundledLanguageFiles: Record<LanguageType, LanguageFile> = { // todo
  "de_AT": { ...de_AT, languageType: "de_AT" },
  "en_GB": { ...en_GB, languageType: "en_GB" } as any as LanguageFile,
  "fr_FR": { ...fr_FR, languageType: "fr_FR" } as any as LanguageFile,
  "it_IT": { ...it_IT, languageType: "it_IT" } as any as LanguageFile,
  "es_ES": { ...es_ES, languageType: "es_ES" } as any as LanguageFile,
}

const bundledLanguageFiles = prepareLanguageFiles(rawBundledLanguageFiles)

export function prepareLanguageFiles(languages: Record<LanguageType, LanguageFile>): Record<LanguageType, LanguageFile> {
  const ret: Record<LanguageType, LanguageFile> = {} as Record<LanguageType, LanguageFile>;
  const keys = getKeys(languages);

  for (const lk of keys) {
    const languageWithFallbacks = [lk, ...languageFallbacks];
    ret[lk] = {} as LanguageFile;
    const l = ret[lk];
    for (const k of Object.keys(languages.de_AT)) {
      const k2 = k as keyof typeof de_AT;

      for (const lf of languageWithFallbacks) {
        const v = languages[lf][k2];
        if (v) {
          l[k2] = v;
          break;
        }
      }
    }
    l.languageType = lk;
  }
  return ret;
}

export function getRawBundledLanguageFiles(): Record<LanguageType, LanguageFile> {
  return rawBundledLanguageFiles;
}

export function getBundledLanguageFiles(): Record<LanguageType, LanguageFile> {
  return bundledLanguageFiles;
}

export function dbToLanguageFile(translations: PartialRecord<string, ILanguageDbItem>): Record<LanguageType, LanguageFile> {
  const blf = getBundledLanguageFiles();
  const languageKeys = getKeys(blf);

  const localisations: PartialRecord<LanguageType, LanguageFile> = {};
  for (const lk of languageKeys) {
    localisations[lk] = { ...blf[lk] };
  }
  for (const tk of getKeys(translations)) {
    const translation = translations[tk];
    for (const lk of languageKeys) {
      const text = translation![lk];
      if (text !== undefined)
        (localisations[lk] as any)[tk] = text as any;
    }
  }
  return prepareLanguageFiles(localisations as Record<LanguageType, LanguageFile>);
}